import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { parse, stringify } from 'qs';

import { CompaniesFiltersDto } from '../../../services/directoryService';
import { useCompaniesList } from '../../../services/hooks/useCompaniesList';
import { routes } from '../../../config/routes';

export const useCompaniesDirectoryList = () => {
  const itemsPerPage = 10;
  const [filters, setFilters] = useState<CompaniesFiltersDto>({
    offset: 0,
    items_per_page: itemsPerPage,
  } as CompaniesFiltersDto);

  const query = useCompaniesList(filters);
  const router = useRouter();

  const handleOffsetChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    const newFilters = { ...filters, offset: page - 1 };
    setFilters(newFilters);

    router.push({
      pathname: routes.DIRECTORY,
      query: stringify(newFilters),
    });
  };

  useEffect(() => {
    if (router.isReady) {
      const rawQuery = parse(router.asPath.split('?')[1]);
      const filtersFromQuery = rawQuery as unknown as CompaniesFiltersDto;

      if (!filtersFromQuery.categories) {
        filtersFromQuery.categories = [null, '-1'];
      }

      if (filtersFromQuery.offset === undefined) {
        filtersFromQuery.offset = 0;
        filtersFromQuery.items_per_page = 10;

        router.replace({
          pathname: routes.DIRECTORY,
          query: stringify(filtersFromQuery),
        });

        return;
      }

      setFilters({
        ...filtersFromQuery,
        offset: Number(filtersFromQuery.offset),
        items_per_page: Number(filtersFromQuery.items_per_page),
      });
    }
  }, [router]);

  const applyFilters = (filters: CompaniesFiltersDto) => {
    setFilters(filters);

    const stringifiedFilters = stringify(filters);

    router.replace({
      pathname: routes.DIRECTORY,
      query: stringifiedFilters,
    });
  };

  return { filters, query, applyFilters, handleOffsetChange };
};
